import {FlexBox, useBreakpoint} from "@brg/ui";
import {
    NearLessonButton,
    NearLessonLeftPart,
    NearLessonLeftPartTime,
    NearLessonLeftPartTitle,
    NearLessonRightPart, NearLessonRightPartItem,
    NearLessonTeach
} from "./styles";
import {CreateLinkTo} from "../../../../constants/linkTo";
import {getFullDate} from "../../../../helpers/LMS/convertToDate";
import {bTag, LayoutConst} from "../../../../../core";
import {useTranslation} from "react-i18next";
import {useGetNearLesson} from "../../../../hooks/api/LMS/useGetNearLesson";
import { getCourseFormatName } from "shared/helpers/LMS/getCourseFormatName";
import { FC, useMemo } from "react";
import { ICourseModuleCard } from "shared/constants/courses/ICourseModuleCard";
import { Lang } from "@brg/api";
import { useRouteMatch } from "react-router-dom";
import { LessonAccessTypes } from "shared/constants/courses/IExtendedLessonItem";
// const mockNearLesson = {
//     lessonInfo: {
//         start: "2024-08-01T11:00:00Z",
//         postId: "12345"
//     },
//     currentLessonNumber: 2,
//     moduleLessonCount: 16,
//     courseFormat: "Online",
//     moduleName: "Основы проектирования. Малый фирменный стиль",
//     courseName: "Коммуникационный дизайн",
//     groups: [
//         { title: "23M1" },
//         { title: "23M2" }
//     ],
//     moduleProjectId: "project123"
// };
export const NearLessonStatus:FC<{ fullWidth?: boolean, module?: ICourseModuleCard<'Local'>, isTeacher?: boolean }> = ({ fullWidth, module, isTeacher }) => {
    const { t, i18n: { language } } = useTranslation();
    const {lesson: nearLesson} = useGetNearLesson();
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const isSchedulePage = !!useRouteMatch("/courses/profile/schedule");
    const isLessonTeacher = nearLesson?.isTeacher

    const nearModule = useMemo(
        () => module, [module])
    
    if (!nearModule && !nearLesson) return null;

    if (nearModule?.nearLesson && nearModule) {
        const startDateStr = getFullDate(nearModule?.nearLesson?.start, language);
        const themeName = nearModule?.nearLesson?.themeName;
        const moduleName = nearModule?.name;
        const moduleNumber = nearModule?.themesCompletedCount;
        const moduleCount = nearModule?.themesCount;
        const moduleId = nearModule?.moduleProjectId;
        const anchorPostSign = nearModule?.nearLesson?.postId;
        const outerLink = window.location.origin + CreateLinkTo.project(moduleId) + '#' + anchorPostSign;

        if (is743) {
            return (
                <FlexBox width="100%" directionMobile="column">
                    <NearLessonLeftPart isLessonTeacher={isLessonTeacher}>
                        <FlexBox direction="column" directionMobile="column">
                            {isLessonTeacher && <NearLessonTeach>{t('my_courses.course_item.teach')}</NearLessonTeach>}
                            <NearLessonLeftPartTitle>{t('my_courses.near_lesson.title')}</NearLessonLeftPartTitle>
                            <NearLessonLeftPartTime>{startDateStr}</NearLessonLeftPartTime>
                        </FlexBox>
                        <NearLessonButton 
                            onClick={() => window.open(outerLink, '_blank')}
                        >
                            {t('my_courses.homework_page.go_to')}
                        </NearLessonButton>
                    </NearLessonLeftPart>
                    <NearLessonRightPart fullWidth={fullWidth}>
                        <FlexBox direction="column" directionMobile="column" gy={4} style={{maxWidth: '100%'}}>
                            <NearLessonRightPartItem>{t('my_courses.homework_page.course')} <span>{moduleName}</span></NearLessonRightPartItem>
                            <NearLessonRightPartItem>{t('my_courses.homework_page.module')} <span>{themeName}</span></NearLessonRightPartItem>
                            <NearLessonRightPartItem>{t('my_courses.homework_page.lesson')} <span>{moduleNumber}/{moduleCount} {getCourseFormatName(nearLesson?.courseFormat, t)}</span></NearLessonRightPartItem>
                            {isTeacher ? (
                              <NearLessonRightPartItem>{t('my_courses.homework_page.group')} <span>{nearLesson?.groups?.length === 0 ? t('my_courses.near_lesson.all') : nearLesson?.groups?.map((group: any) => group?.name || t('teams.adminPage.fields.group'))?.join(', ')}</span></NearLessonRightPartItem>
                            ) : null}
                        </FlexBox>
                    </NearLessonRightPart>
                </FlexBox>
            )
        }
        return (
            <FlexBox width="100%" offsetBottom={24}>
                <NearLessonLeftPart isLessonTeacher={isLessonTeacher}>
                    <FlexBox direction="column" directionMobile="column">
                        {isLessonTeacher && <NearLessonTeach>{t('my_courses.course_item.teach')}</NearLessonTeach>}
                        <NearLessonLeftPartTitle>{t('my_courses.near_lesson.title')}</NearLessonLeftPartTitle>
                        <NearLessonLeftPartTime>{startDateStr}</NearLessonLeftPartTime>
                    </FlexBox>
                    <NearLessonButton 
                        onClick={() => window.open(outerLink, '_blank')}
                    >
                        {t('my_courses.homework_page.go_to')}
                    </NearLessonButton>
                </NearLessonLeftPart>
                <NearLessonRightPart fullWidth={fullWidth}>
                    <FlexBox widthMobile={''} direction="column" directionMobile="column" gy={8} offsetLeft={16} style={{maxWidth: '400px', width: '50%'}}>
                        <NearLessonRightPartItem>
                            {t('my_courses.homework_page.module')} <span>{moduleName}</span>
                        </NearLessonRightPartItem>
                        <NearLessonRightPartItem>
                            {t('my_courses.homework_page.theme')} <span>{themeName}</span>
                        </NearLessonRightPartItem>
                    </FlexBox>
                    <FlexBox direction="column" directionMobile="column" gy={8} offsetLeft={16} offsetLeftMobile={8} style={{maxWidth: '400px', width: '50%'}}>
                        <NearLessonRightPartItem>
                            {t('my_courses.homework_page.lesson')} <span>{moduleNumber}/{moduleCount} {getCourseFormatName(nearLesson?.courseFormat, t)}</span>
                        </NearLessonRightPartItem>
                        {isTeacher ? (
                              <NearLessonRightPartItem>{t('my_courses.homework_page.group')} <span>{nearLesson?.groups?.length === 0 ? t('my_courses.near_lesson.all') : nearLesson?.groups?.map((group: any) => group?.name || t('teams.adminPage.fields.group'))?.join(', ')}</span></NearLessonRightPartItem>
                        ) : (
                            <NearLessonRightPartItem style={{ marginTop: 18 }}><span></span></NearLessonRightPartItem>
                        )}
                    </FlexBox>
                </NearLessonRightPart>
            </FlexBox>
        )
    }

    if(is743){
        return <FlexBox width="100%" directionMobile="column">
        <NearLessonLeftPart isLessonTeacher={isLessonTeacher}>
            <FlexBox direction="column" directionMobile="column">
                {isLessonTeacher && <NearLessonTeach>{t('my_courses.course_item.teach')}</NearLessonTeach>}
                <NearLessonLeftPartTitle>{t('my_courses.near_lesson.title')}</NearLessonLeftPartTitle>
                <NearLessonLeftPartTime>{getFullDate(nearLesson?.lessonInfo?.start, language)}</NearLessonLeftPartTime>
            </FlexBox>
            <NearLessonButton onClick={() => window.open(window.location.origin + CreateLinkTo.project(nearLesson?.moduleProjectId) + '#' + nearLesson?.lessonInfo?.postId, '_blank')}>{t('my_courses.homework_page.go_to')}</NearLessonButton>
        </NearLessonLeftPart>
        <NearLessonRightPart fullWidth={fullWidth}>
            <FlexBox direction="column" directionMobile="column" gy={4} style={{maxWidth: '100%'}}>
                <NearLessonRightPartItem>{t('my_courses.homework_page.course')} <span>{nearLesson?.courseName}</span></NearLessonRightPartItem>
                <NearLessonRightPartItem>{t('my_courses.homework_page.module')} <span>{nearLesson?.moduleName}</span></NearLessonRightPartItem>
                <NearLessonRightPartItem>{t('my_courses.homework_page.theme')} <span>{Lang(nearLesson?.themeName, language)}</span></NearLessonRightPartItem>
                <NearLessonRightPartItem>{t('my_courses.homework_page.lesson')} <span>{nearLesson?.currentLessonNumber}/{nearLesson?.moduleLessonCount} {getCourseFormatName(nearLesson?.courseFormat, t)}</span></NearLessonRightPartItem>
                {isTeacher ? (
                    <NearLessonRightPartItem>{t('my_courses.homework_page.group')} <span>{nearLesson?.groups?.length === 0 ? t('my_courses.near_lesson.all') : nearLesson?.groups?.map((group: any) => group?.name || t('teams.adminPage.fields.group'))?.join(', ')}</span></NearLessonRightPartItem>
                ) : null}
            </FlexBox>
        </NearLessonRightPart>
    </FlexBox>
    }

    return <FlexBox width="100%" style={{ maxWidth: isSchedulePage ? '900px': '100%'}} offsetBottom={24}>
        <NearLessonLeftPart isLessonTeacher={isLessonTeacher}>
                <FlexBox direction="column" directionMobile="column">
                    {isLessonTeacher && <NearLessonTeach>{t('my_courses.course_item.teach')}</NearLessonTeach>}
                    <NearLessonLeftPartTitle>{t('my_courses.near_lesson.title')}</NearLessonLeftPartTitle>
                    <NearLessonLeftPartTime>{getFullDate(nearLesson?.lessonInfo?.start, language)}</NearLessonLeftPartTime>
                </FlexBox>
                <NearLessonButton onClick={() => window.open(window.location.origin + CreateLinkTo.project(nearLesson?.moduleProjectId) + '#' + nearLesson?.lessonInfo?.postId, '_blank')}>{t('my_courses.homework_page.go_to')}</NearLessonButton>
        </NearLessonLeftPart>
        <NearLessonRightPart>
            <FlexBox direction="column" directionMobile="column" gy={8} offsetLeft={16} style={{maxWidth: '50%', width: '50%'}}>
                <NearLessonRightPartItem>{t('my_courses.homework_page.course')} <span>{nearLesson?.courseName}</span></NearLessonRightPartItem>
                <NearLessonRightPartItem>{t('my_courses.homework_page.module')} <span>{nearLesson?.moduleName}</span></NearLessonRightPartItem>
            </FlexBox>
            <FlexBox direction="column" directionMobile="column" gy={8} offsetLeft={16} style={{maxWidth: '400px' , width: '50%'}}>
                <NearLessonRightPartItem>{t('my_courses.homework_page.theme')} <span>{Lang(nearLesson?.themeName, language)}</span></NearLessonRightPartItem>
                <NearLessonRightPartItem>{t('my_courses.homework_page.lesson')} <span>{nearLesson?.currentLessonNumber}/{nearLesson?.moduleLessonCount} {getCourseFormatName(nearLesson?.courseFormat, t)}</span></NearLessonRightPartItem>
            </FlexBox>
            {isTeacher && (
                <FlexBox direction="column">
                    <NearLessonRightPartItem>{t('my_courses.homework_page.group')} <span>{nearLesson?.groups?.length === 0 ? t('my_courses.near_lesson.all') : nearLesson?.groups?.map((group: any) => group?.name || t('teams.adminPage.fields.group'))?.join(', ')}</span></NearLessonRightPartItem>
                    <NearLessonRightPartItem style={{ marginTop:  18 }}><span></span></NearLessonRightPartItem>
                </FlexBox>
            )}
        </NearLessonRightPart>
    </FlexBox>
}import {FlexBox, useBreakpoint} from "@brg/ui";
import {
    NearLessonButton,
    NearLessonLeftPart,
    NearLessonLeftPartTime,
    NearLessonLeftPartTitle,
    NearLessonRightPart, NearLessonRightPartItem,
    NearLessonTeach
} from "./styles";
import {CreateLinkTo} from "../../../../constants/linkTo";
import {getFullDate} from "../../../../helpers/LMS/convertToDate";
import {bTag, LayoutConst} from "../../../../../core";
import {useTranslation} from "react-i18next";
import {useGetNearLesson} from "../../../../hooks/api/LMS/useGetNearLesson";
import { getCourseFormatName } from "shared/helpers/LMS/getCourseFormatName";
import { FC, useMemo } from "react";
import { ICourseModuleCard } from "shared/constants/courses/ICourseModuleCard";
import { Lang } from "@brg/api";
import { useRouteMatch } from "react-router-dom";
import { LessonAccessTypes } from "shared/constants/courses/IExtendedLessonItem";
// const mockNearLesson = {
//     lessonInfo: {
//         start: "2024-08-01T11:00:00Z",
//         postId: "12345"
//     },
//     currentLessonNumber: 2,
//     moduleLessonCount: 16,
//     courseFormat: "Online",
//     moduleName: "Основы проектирования. Малый фирменный стиль",
//     courseName: "Коммуникационный дизайн",
//     groups: [
//         { title: "23M1" },
//         { title: "23M2" }
//     ],
//     moduleProjectId: "project123"
// };
export const NearLessonStatus:FC<{ fullWidth?: boolean, module?: ICourseModuleCard<'Local'>, isTeacher?: boolean }> = ({ fullWidth, module, isTeacher }) => {
    const { t, i18n: { language } } = useTranslation();
    const {lesson: nearLesson} = useGetNearLesson();
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const isSchedulePage = !!useRouteMatch("/courses/profile/schedule");
    const isLessonTeacher = nearLesson?.isTeacher

    const nearModule = useMemo(
        () => module, [module])
    
    if (!nearModule && !nearLesson) return null;

    if (nearModule?.nearLesson && nearModule) {
        const startDateStr = getFullDate(nearModule?.nearLesson?.start, language);
        const themeName = nearModule?.nearLesson?.themeName;
        const moduleName = nearModule?.name;
        const moduleNumber = nearModule?.themesCompletedCount;
        const moduleCount = nearModule?.themesCount;
        const moduleId = nearModule?.moduleProjectId;
        const anchorPostSign = nearModule?.nearLesson?.postId;
        const outerLink = window.location.origin + CreateLinkTo.project(moduleId) + '#' + anchorPostSign;

        if (is743) {
            return (
                <FlexBox width="100%" directionMobile="column">
                    <NearLessonLeftPart isLessonTeacher={isLessonTeacher}>
                        <FlexBox direction="column" directionMobile="column">
                            {isLessonTeacher && <NearLessonTeach>{t('my_courses.course_item.teach')}</NearLessonTeach>}
                            <NearLessonLeftPartTitle>{t('my_courses.near_lesson.title')}</NearLessonLeftPartTitle>
                            <NearLessonLeftPartTime>{startDateStr}</NearLessonLeftPartTime>
                        </FlexBox>
                        <NearLessonButton 
                            onClick={() => window.open(outerLink, '_blank')}
                        >
                            {t('my_courses.homework_page.go_to')}
                        </NearLessonButton>
                    </NearLessonLeftPart>
                    <NearLessonRightPart fullWidth={fullWidth}>
                        <FlexBox direction="column" directionMobile="column" gy={4} style={{maxWidth: '100%'}}>
                            <NearLessonRightPartItem>{t('my_courses.homework_page.course')} <span>{moduleName}</span></NearLessonRightPartItem>
                            <NearLessonRightPartItem>{t('my_courses.homework_page.module')} <span>{themeName}</span></NearLessonRightPartItem>
                            <NearLessonRightPartItem>{t('my_courses.homework_page.lesson')} <span>{moduleNumber}/{moduleCount} {getCourseFormatName(nearLesson?.courseFormat, t)}</span></NearLessonRightPartItem>
                            {isTeacher ? (
                              <NearLessonRightPartItem>{t('my_courses.homework_page.group')} <span>{nearLesson?.groups?.length === 0 ? t('my_courses.near_lesson.all') : nearLesson?.groups?.map((group: any) => group?.name || t('teams.adminPage.fields.group'))?.join(', ')}</span></NearLessonRightPartItem>
                            ) : null}
                        </FlexBox>
                    </NearLessonRightPart>
                </FlexBox>
            )
        }
        return (
            <FlexBox width="100%" offsetBottom={24}>
                <NearLessonLeftPart isLessonTeacher={isLessonTeacher}>
                    <FlexBox direction="column" directionMobile="column">
                        {isLessonTeacher && <NearLessonTeach>{t('my_courses.course_item.teach')}</NearLessonTeach>}
                        <NearLessonLeftPartTitle>{t('my_courses.near_lesson.title')}</NearLessonLeftPartTitle>
                        <NearLessonLeftPartTime>{startDateStr}</NearLessonLeftPartTime>
                    </FlexBox>
                    <NearLessonButton 
                        onClick={() => window.open(outerLink, '_blank')}
                    >
                        {t('my_courses.homework_page.go_to')}
                    </NearLessonButton>
                </NearLessonLeftPart>
                <NearLessonRightPart fullWidth={fullWidth}>
                    <FlexBox widthMobile={''} direction="column" directionMobile="column" gy={8} offsetLeft={16} style={{maxWidth: '400px', width: '50%'}}>
                        <NearLessonRightPartItem>
                            {t('my_courses.homework_page.module')} <span>{moduleName}</span>
                        </NearLessonRightPartItem>
                        <NearLessonRightPartItem>
                            {t('my_courses.homework_page.theme')} <span>{themeName}</span>
                        </NearLessonRightPartItem>
                    </FlexBox>
                    <FlexBox direction="column" directionMobile="column" gy={8} offsetLeft={16} offsetLeftMobile={8} style={{maxWidth: '400px', width: '50%'}}>
                        <NearLessonRightPartItem>
                            {t('my_courses.homework_page.lesson')} <span>{moduleNumber}/{moduleCount} {getCourseFormatName(nearLesson?.courseFormat, t)}</span>
                        </NearLessonRightPartItem>
                        {isTeacher ? (
                              <NearLessonRightPartItem>{t('my_courses.homework_page.group')} <span>{nearLesson?.groups?.length === 0 ? t('my_courses.near_lesson.all') : nearLesson?.groups?.map((group: any) => group?.name || t('teams.adminPage.fields.group'))?.join(', ')}</span></NearLessonRightPartItem>
                        ) : (
                            <NearLessonRightPartItem style={{ marginTop: 18 }}><span></span></NearLessonRightPartItem>
                        )}
                    </FlexBox>
                </NearLessonRightPart>
            </FlexBox>
        )
    }

    if(is743){
        return <FlexBox width="100%" directionMobile="column">
        <NearLessonLeftPart isLessonTeacher={isLessonTeacher}>
            <FlexBox direction="column" directionMobile="column">
                {isLessonTeacher && <NearLessonTeach>{t('my_courses.course_item.teach')}</NearLessonTeach>}
                <NearLessonLeftPartTitle>{t('my_courses.near_lesson.title')}</NearLessonLeftPartTitle>
                <NearLessonLeftPartTime>{getFullDate(nearLesson?.lessonInfo?.start, language)}</NearLessonLeftPartTime>
            </FlexBox>
            <NearLessonButton onClick={() => window.open(window.location.origin + CreateLinkTo.project(nearLesson?.moduleProjectId) + '#' + nearLesson?.lessonInfo?.postId, '_blank')}>{t('my_courses.homework_page.go_to')}</NearLessonButton>
        </NearLessonLeftPart>
        <NearLessonRightPart fullWidth={fullWidth}>
            <FlexBox direction="column" directionMobile="column" gy={4} style={{maxWidth: '100%'}}>
                <NearLessonRightPartItem>{t('my_courses.homework_page.course')} <span>{nearLesson?.courseName}</span></NearLessonRightPartItem>
                <NearLessonRightPartItem>{t('my_courses.homework_page.module')} <span>{nearLesson?.moduleName}</span></NearLessonRightPartItem>
                <NearLessonRightPartItem>{t('my_courses.homework_page.theme')} <span>{Lang(nearLesson?.themeName, language)}</span></NearLessonRightPartItem>
                <NearLessonRightPartItem>{t('my_courses.homework_page.lesson')} <span>{nearLesson?.currentLessonNumber}/{nearLesson?.moduleLessonCount} {getCourseFormatName(nearLesson?.courseFormat, t)}</span></NearLessonRightPartItem>
                {isTeacher ? (
                    <NearLessonRightPartItem>{t('my_courses.homework_page.group')} <span>{nearLesson?.groups?.length === 0 ? t('my_courses.near_lesson.all') : nearLesson?.groups?.map((group: any) => group?.name || t('teams.adminPage.fields.group'))?.join(', ')}</span></NearLessonRightPartItem>
                ) : null}
            </FlexBox>
        </NearLessonRightPart>
    </FlexBox>
    }

    return <FlexBox width="100%" style={{ maxWidth: isSchedulePage ? '900px': '100%'}} offsetBottom={24}>
        <NearLessonLeftPart isLessonTeacher={isLessonTeacher}>
                <FlexBox direction="column" directionMobile="column">
                    {isLessonTeacher && <NearLessonTeach>{t('my_courses.course_item.teach')}</NearLessonTeach>}
                    <NearLessonLeftPartTitle>{t('my_courses.near_lesson.title')}</NearLessonLeftPartTitle>
                    <NearLessonLeftPartTime>{getFullDate(nearLesson?.lessonInfo?.start, language)}</NearLessonLeftPartTime>
                </FlexBox>
                <NearLessonButton onClick={() => window.open(window.location.origin + CreateLinkTo.project(nearLesson?.moduleProjectId) + '#' + nearLesson?.lessonInfo?.postId, '_blank')}>{t('my_courses.homework_page.go_to')}</NearLessonButton>
        </NearLessonLeftPart>
        <NearLessonRightPart>
            <FlexBox direction="column" directionMobile="column" gy={8} offsetLeft={16} style={{maxWidth: '50%', width: '50%'}}>
                <NearLessonRightPartItem>{t('my_courses.homework_page.course')} <span>{nearLesson?.courseName}</span></NearLessonRightPartItem>
                <NearLessonRightPartItem>{t('my_courses.homework_page.module')} <span>{nearLesson?.moduleName}</span></NearLessonRightPartItem>
            </FlexBox>
            <FlexBox direction="column" directionMobile="column" gy={8} offsetLeft={16} style={{maxWidth: '400px' , width: '50%'}}>
                <NearLessonRightPartItem>{t('my_courses.homework_page.theme')} <span>{Lang(nearLesson?.themeName, language)}</span></NearLessonRightPartItem>
                <NearLessonRightPartItem>{t('my_courses.homework_page.lesson')} <span>{nearLesson?.currentLessonNumber}/{nearLesson?.moduleLessonCount} {getCourseFormatName(nearLesson?.courseFormat, t)}</span></NearLessonRightPartItem>
            </FlexBox>
            {isTeacher && (
                <FlexBox direction="column">
                    <NearLessonRightPartItem>{t('my_courses.homework_page.group')} <span>{nearLesson?.groups?.length === 0 ? t('my_courses.near_lesson.all') : nearLesson?.groups?.map((group: any) => group?.name || t('teams.adminPage.fields.group'))?.join(', ')}</span></NearLessonRightPartItem>
                    <NearLessonRightPartItem style={{ marginTop:  18 }}><span></span></NearLessonRightPartItem>
                </FlexBox>
            )}
        </NearLessonRightPart>
    </FlexBox>
}